/* eslint-disable */
/*NOT USE*/
import {ColumnConfig, IColumnConfig} from './columnConfig';

export class PasswordColumnConfig extends ColumnConfig {
  constructor(config: IColumnConfig) {
    if (!config.editTemplateName) config.editTemplateName = '';
    super(config);
  }
}